module.exports = __webpack_public_path__ + "img/b-icon_envelope(1).8ecc4eb1.svg";